import { router, usePage } from "@inertiajs/react";
import { accountSwitchPath, newAccountPath, profilePath } from "@travily/routes";
import type Account from "@travily/types/models/Account";
import type { AccountSwitcherProps } from "@/components/AppMenu/AppMenu";
import type { SharedProps } from "@/types";

function buildAccountSwitcher(
  currentAccount: Account | null,
  accounts: Account[],
  userInitial: string | null,
): AccountSwitcherProps {
  const otherAccounts = currentAccount ? accounts.filter((a) => a.id !== currentAccount.id) : [];

  return {
    currentAccount: currentAccount ?? undefined,
    otherAccounts,
    addAccountHref: newAccountPath(),
    profileHref: currentAccount?.handle ? profilePath(currentAccount.handle) : undefined,
    userInitial: userInitial ?? undefined,
    onSwitchAccount: (accountId: number) => {
      router.post(accountSwitchPath(), { account_id: accountId });
    },
  };
}

export function useAccountSwitcher(): AccountSwitcherProps | undefined {
  const { current_user, current_account, accounts } = usePage<SharedProps>().props;

  if (!current_user || !accounts) return undefined;

  return buildAccountSwitcher(current_account, accounts, current_user.initial);
}
